<template>
  <div class="relative">
    <svg
      width="180"
      viewBox="0 0 180 90"
      xmlns="http://www.w3.org/2000/svg"
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
    >
      <path
        d="M180 90h-6a83.93 83.93 0 00-4.255-26.467l4.71-4.708C178.04 68.54 180 79.041 180 90z"
        fill="#f9bb61"
      />
      <path
        d="M90 0c37.654 0 69.907 23.124 83.334 55.945l-4.631 4.632C156.779 28.697 126.04 6 90 6 53.96 6 23.22 28.697 11.297 60.578l-4.631-4.633C20.093 23.124 52.346 0 90 0z"
        fill="#6acd6b"
      />
      <path
        d="M5.546 58.824l4.708 4.71A83.923 83.923 0 006 90H0c0-10.96 1.959-21.462 5.546-31.176z"
        fill="#e06a54"
      />
      <path
        v-if="value"
        d="M90 11.455s3.983 71.263 3.983 73.853C93.983 87.898 92.198 90 90 90c-2.198 0-3.982-2.103-3.982-4.692 0-2.59 3.982-73.853 3.982-73.853z"
        :transform="`rotate(${degrees}, 90, 84)`"
      />
    </svg>
    <template v-if="labels">
      <div
        class="absolute overline navy--text font-weight-medium"
        style="bottom: -26px; left: -20px"
      >
        Specifické
      </div>
      <div
        class="absolute overline navy--text font-weight-medium"
        style="bottom: -26px; right: -20px"
      >
        Široké
      </div>
    </template>
  </div>
</template>

<script>
import clamp from "lodash/clamp"

export default {
  name: "ReachDialBox",
  props: {
    value: { type: Number, required: true },
    labels: { type: Boolean, default: true },
  },
  computed: {
    degrees() {
      return clamp(this.value, 0, 1) * 180 - 90
    },
  },
}
</script>
